var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_92983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.15003 14.849C0.480369 14.1793 0.480375 13.0936 1.15004 12.424L5.57458 7.99951L1.15003 3.57501C0.480372 2.90535 0.480376 1.81963 1.15004 1.14998C1.81969 0.480344 2.9054 0.480354 3.57504 1.15L7.99951 5.57452L12.4241 1.14999C13.0937 0.48035 14.1794 0.48036 14.8491 1.15001C15.5187 1.81965 15.5187 2.90533 14.8491 3.57496L10.4246 7.99951L14.8491 12.424C15.5187 13.0936 15.5187 14.1793 14.8491 14.849C14.1795 15.5186 13.0937 15.5187 12.4241 14.849L7.99951 10.4245L3.57506 14.849C2.90541 15.5187 1.81968 15.5187 1.15003 14.849Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_92983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBig);
export default __webpack_public_path__ + "static/media/IconClose-big.3dc89557.svg";
export { ForwardRef as ReactComponent };